/**
 * Project Name : cop-web-portal
 * File Name : columnFixChange.js
 * Description : 컬럼 고정 위치 값 조정 js
 * Author : dhoop.lee
 * Date : 2023.7.12
 */
export default function columnFixChange(el) {
  const { nodeName } = el;
  if (['TABLE'].indexOf(nodeName) < 0) return;
  // 고정된 컬럼들을 구한다.
  const ths = el.querySelector('thead').querySelectorAll('th[data-fix=sticky_column]');
  if (ths.length < 1) return;
  const trs = el.querySelector('tbody').querySelectorAll('tr');
  let widthSum = 0;
  // 각 고정된 컬럼들의 위치를 그 전까지 고정된 컬럼의 Width의 합으로 결정한다.
  ths.forEach((th, idx) => {
    th.style.left = `${widthSum}px`;
    trs.forEach(tr => {
      const tds = tr.querySelectorAll('td[data-fix=sticky_column]');
      if (tds[idx]) tds[idx].style.left = `${widthSum}px`;
    });
    // 실제 고정 컬럼들의 Width의 합
    widthSum += ths[idx].offsetWidth;
  });
}



// WEBPACK FOOTER //
// ./src/directives/columnFixChange.js